import fetchOverviewDataReducer from "./fetchOverviewDataReducer";


export default {
    fetchOverviewDataReducer
}